import { BlockType } from '@/types';
import type { Template } from '@/types';

/** Pagina's die alleen uit tekst bestaan; elk ander bloktype (cover, team, investering…) telt als inhoud. */
const TEXT_ONLY_TYPES = new Set<string>([BlockType.CONTENT_PAGE, BlockType.TEXT]);

function visibleText(html: unknown): string {
  if (typeof html !== 'string') return '';
  if (/<(img|table|iframe|video)\b/i.test(html)) return 'media';
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;|&#160;/g, ' ')
    .trim();
}

/**
 * Leeg = geen pagina's, of alleen tekstpagina's zonder titel en tekst (zoals een
 * nieuwe lege template die nooit is ingevuld). Zo'n template levert een lege
 * offerte op, dus de kaart laat hem zien als leeg en biedt verwijderen aan.
 */
export function isTemplateEmpty(template: Pick<Template, 'blocks'>): boolean {
  return template.blocks.every((block) => {
    if (!TEXT_ONLY_TYPES.has(block.type)) return false;
    const content = (block.content ?? {}) as { title?: unknown; content?: unknown; html?: unknown };
    return !visibleText(content.title) && !visibleText(content.content) && !visibleText(content.html);
  });
}
